var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAlertFail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ueo6pne9da",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2388"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 92",
    d: "M48.5 5a43.513 43.513 0 0 0-16.931 83.584A43.513 43.513 0 0 0 65.431 8.416 43.223 43.223 0 0 0 48.5 5m0-5A48.5 48.5 0 1 1 0 48.5 48.5 48.5 0 0 1 48.5 0z",
    style: {
      fill: "url(#ueo6pne9da)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3749",
    d: "M-21733-1990.5h46.238",
    transform: "translate(21758.5 2039)",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeWidth: 6
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAlertFail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-alertFail.435a71b0ad728217773679dea3fe5586.svg";